import api from "../../index";

export const GetDeletedClientApi = () => api.post("get-deleted-clients");
export const RestoreClientApi = (data) => api.post("restore-deleted-client", data);
